<template>
    <div class="user-lists-modal duplicate-list-dialog">

        <!-- Shadow -->
        <div class="user-lists-modal__shade" @click="closeModal"></div>

        <!-- Modal -->
        <div class="user-lists-modal__inner" v-if="currentList">

            <!-- Close Modal -->
            <span class="user-lists-modal__close" @click="closeModal">
                <svg class='close'><use xlink:href="#close"></use></svg>
            </span>

            <!-- Header -->
            <h2>Duplicate List</h2>

            <p class="info">
                Duplicating a list will allow you to customize it and make it your own.<br>
                The original creators' notes will still appear.
            </p>


            <!-- Form -->
            <form :action="`/lists/${currentList.id}/duplicate`" method="post" @submit.prevent="submit">

                <!-- Name -->
                <div class="form__row">
                    <div class="form__row__left">
                        <label for="list-name">Name*</label>
                    </div>
                    <div class="form__row__right">
                        <div class="form__field">
                            <input type="text"
                                   id="list-name"
                                   name="list-name"
                                   :placeholder="`${currentList.name} (Copy)`"
                                   class="required"
                                   v-model="form.name">
                        </div>
                        <div class="error" v-if="form.errors.name" v-text="form.errors.name"></div>
                    </div>
                </div>

                <!-- Description -->
                <div class="form__row">
                    <div class="form__row__left">
                        <label for="description">Description</label>
                    </div>
                    <div class="form__row__right">
                        <div class="form__field ">
                        <textarea style="resize: none;"
                                  id="description"
                                  rows="5"
                                  v-model="form.description"
                                  name="description"
                                  placeholder="Add some notes">
                        </textarea>
                        </div>
                        <div class="error" v-if="form.errors.description" v-text="form.errors.description"></div>
                    </div>
                </div>

                <!-- Trip Days -->
                <div class="form__row form__date">
                    <div class="form__row__left">
                        <label for="trip_dates">Trip Dates</label>
                    </div>
                    <div class="form__row__right">
                        <div class="form__field">
                            <input type="text"
                                   style="cursor: pointer"
                                   @click="selectDates('open-duplicate-list-dialog')"
                                   placeholder="Add trip dates or days (optional)" readonly :value="inputDateValue">
                            <span class="text-info">Trip dates/days are optional. Only you can see trip dates.</span>
                        </div>
                    </div>
                </div>


                <!-- Secret -->
                <div class="form__row secret-toggle-row">
                    <div class="form__row__left">
                        <label>Secret List</label>
                    </div>
                    <div class="form__row__right">
                        <div class="form__field secret-toggle">
                            <input type="checkbox"
                                   name="secret"
                                   id="secret"
                                   v-model="form.secret" >
                            <div class="switch"><span></span></div>
                            <p style="padding: 0px; width: 60%; margin-left: 20px">If you make this list secret, only you will be able to see it.</p>
                        </div>
                    </div>
                </div>

                <!-- Submit Button -->
                <div class="form__button">
                    <button type="submit"
                            :class="{ 'is-submitting dis': form.isSubmitted }"
                            :disabled="form.isSubmitted"
                            class="button">
                        {{ form.isSubmitted ? 'Duplicating' : 'Duplicate List' }}
                        <svg class="arrow-right-2"><use xlink:href="#arrow-right-2"></use></svg>
                    </button>
                </div>

            </form>
        </div>
    </div>
</template>

<script>

import Form from '@/classes/Form'
import Helpers from "@/mixins/Helpers"
import TripDates from "@/mixins/TripDates"

export default {

    mixins:[TripDates, Helpers],

    props: ['list'],

    data() {
        return {
            currentList: this.list,
            form: new Form({
                name: '',
                description: '',
                secret: false,
                trip_date: this.list.trip_date,
                trip_days: this.list.trip_days
            })
        }
    },

    created() {
        eventBus.$on('open-duplicate-list-modal', (list) => {
            this.currentList = list;
            this.openModal();
        });
        eventBus.$on('open-duplicate-list-dialog', event => {
            this.form.trip_date = event.trip_date
            this.form.trip_days = event.trip_days
            this.openModal()
        });
    },

    methods: {

        submit() {
            this.form.post(`/lists/${this.currentList.id}/duplicate`)
                .then(response => {
                    eventBus.$emit('list-duplicated', response)
                    this.closeModal()
                })
                .catch(errors => {
                    console.log(errors)
                })
        },

        openModal(){
            $('.duplicate-list-dialog').fadeIn()
        },

        closeModal(){
            $('.duplicate-list-dialog').fadeOut();
        }
    }
}
</script>
